import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExpenditureSubjectModel } from '../../models/ExpenditureSubjectModel'


export interface ExpenditureSubjectState {
    ExpenditureSubject: ExpenditureSubjectModel
    ExpenditureSubjectList: ExpenditureSubjectModel[]
}

const initialState: ExpenditureSubjectState = {
    ExpenditureSubject: {} as ExpenditureSubjectModel,
    ExpenditureSubjectList: [],
}

export const ExpenditureSubjectSlice = createSlice({
    name: 'expenditureSubject',
    initialState,
    reducers: {
        setExpenditureSubject: (state, action: PayloadAction<ExpenditureSubjectModel[]>) => {
            state.ExpenditureSubjectList = action.payload
        },
        saveExpenditureSubject: (state, action: PayloadAction<ExpenditureSubjectModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: ExpenditureSubjectModel = { Id: 0, SubjectName: room.SubjectName }
                let currentRoom =
                    state.ExpenditureSubjectList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.SubjectName = room.SubjectName
            } else {
                room.Id = (Math.max(...state.ExpenditureSubjectList.map((c) => c.Id)) || 0) + 1
                state.ExpenditureSubjectList.push(room)
            }
        },
        getExpenditureSubjectById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let ExpenditureSubject: ExpenditureSubjectModel = {} as ExpenditureSubjectModel
            if (id > 0) {
                let currentExpenditureSubject: ExpenditureSubjectModel[] = state.ExpenditureSubjectList
                ExpenditureSubject = currentExpenditureSubject.find((c) => c.Id === id) || ({} as ExpenditureSubjectModel)
            }

            state.ExpenditureSubject = ExpenditureSubject
        },
        deleteExpenditureSubject: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentExpenditureSubject: ExpenditureSubjectModel[] = state.ExpenditureSubjectList
                state.ExpenditureSubjectList = currentExpenditureSubject.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setExpenditureSubject, saveExpenditureSubject, getExpenditureSubjectById, deleteExpenditureSubject } =
ExpenditureSubjectSlice.actions

export default ExpenditureSubjectSlice.reducer
